module.exports = __webpack_public_path__ + "static/media/Timer_displayed_screen@3x.2f5a6b2f.png";